function input({ target: el})
{
	if (!el.required && el.value === "") {
		el.setCustomValidity("");
	}
	else if (el.value.match(/^\d{4}\.\d{2}\.\d{5}$/)) {
		el.setCustomValidity("");
	}
	else if (el.value.match(/^\d{11}$/)) {
		el.value = `${el.value.slice(0, 4)}.${el.value.slice(4, 6)}.${el.value.slice(6, 11)}`;
		el.setCustomValidity("");
	}
	else {
		el.setCustomValidity("Vennligst fyll inn et gyldig bankkontonummer");
	}
}

export default {
	created:   el => el.addEventListener("input", input, true),
	unmounted: el => el.removeEventListener("input", input, true)
};
